import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import BenefitsSection from './components/BenefitsSection';
import WhyChooseUs from './components/WhyChooseUs';
import TestimonialsSection from './components/TestimonialsSection';
import TrustBadges from './components/TrustBadges';
import HomeCTASection from './components/HomeCTASection';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'LocalBusiness',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#business`,
      name: 'ORPM Investment LLC',
      url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
      telephone: '+15615122820',
      email: 'info@orpminvestment.com',
      description: 'Sistemas premium de purificación de agua e instalación profesional de ventanas para hogares y negocios en Georgia.',
      priceRange: '$$',
      image: `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/og-image.jpg`,
      address: {
        '@type': 'PostalAddress',
        streetAddress: '3202 Lealand Pl Ln',
        addressLocality: 'Lawrenceville',
        addressRegion: 'GA',
        postalCode: '30044',
        addressCountry: 'US',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 33.9565,
        longitude: -83.9879,
      },
      areaServed: {
        '@type': 'State',
        name: 'Georgia',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios ORPM Investment',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Purificación de Agua',
              description: 'Sistemas de purificación y filtración de agua para el hogar y negocios en Georgia.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Instalación de Ventanas',
              description: 'Instalación y reemplazo profesional de ventanas de alta eficiencia energética en Georgia.',
            },
          },
        ],
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#website`,
      url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
      name: 'ORPM Investment LLC',
      inLanguage: ['es-US', 'en-US'],
      publisher: {
        '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#business`,
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#webpage`,
      url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
      name: 'ORPM Investment LLC | Purificación de Agua e Instalación de Ventanas en Georgia',
      description: 'ORPM Investment LLC ofrece sistemas de purificación de agua y servicios profesionales de instalación de ventanas en Georgia.',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#business` },
      inLanguage: 'es-US',
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(HOME_SCHEMA);
    document.title = 'ORPM Investment LLC | Purificación de Agua e Instalación de Ventanas en Georgia';
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ServicesOverview />
        <BenefitsSection />
        <WhyChooseUs />
        <TestimonialsSection />
        <TrustBadges />
        <HomeCTASection />
      </main>
      <Footer />
    </div>
  );
}
